module.exports = __webpack_public_path__ + "media/images/accounts-track-685621e01ea097c0e015d25515c51541.jpg";